<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class=" mx-auto px-4 sm:px-4 lg:px-4 py-4">
    <!-- Collection Tabs -->
    <div class="mb-8">
      <div class="border-b border-gray-200 dark:border-gray-700">
        <nav class="tab-navigation -mb-px overflow-x-auto" aria-label="Tabs">
          <button
          *ngFor="let tab of collectionTabs(); trackBy: trackByCollectionName"
            (click)="navigateToTab(tab.collectionName)"
            [class]="isActive(tab.collectionName)
              ? 'tab-button tab-active whitespace-nowrap py-2 px-3 border-b-2 font-medium text-sm border-green-500 text-green-600 dark:text-green-400'
              : 'tab-button whitespace-nowrap py-2 px-3 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'"
            type="button">
            {{ tab.label }}
          </button>
        </nav>
      </div>
    </div>

    <!-- Tab Description Header -->
    <div class="mb-6 bg-white dark:bg-gray-800 rounded-lg shadow p-6" *ngIf="activeTabDetails()">
      <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
        {{ activeTabDetails()?.label }}
      </h2>
      <p class="text-gray-600 dark:text-gray-300">
        {{ activeTabDetails()?.description }}
      </p>
    </div>

    <!-- Stock Table -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
